@if (model?.data) {
@if(model.data.typeData?.showBreadcrumb) {
<div class="p-t-15 p-b-15 p-b-8-m p-b-8-s p-t-8-m p-t-8-s"
     [class.bg-col-1]="model.data.typeData.darkBreadcrumb">
    <breadcrumbs [variant]="model.data.typeData.darkBreadcrumb ? 'default' : 'light'"
                 class="block wrap">
    </breadcrumbs>
</div>
}
@switch (model.data.pageType) {
<!-- store finder -->
@case ('storeFinder') {
<page-store-finder [content]="model.data.typeData">
</page-store-finder>
}

@case ('material-calculator') {
<cms-material-calculator-page [model]="model"
                              [data]="model.data"
                              [typeData]="model.data.typeData"></cms-material-calculator-page>
}

<!-- blog post -->
@case ('blog-post') {
<cms-blog-page-post-view [model]="model"
                         [data]="model.data"
                         [typeData]="model.data.typeData">
</cms-blog-page-post-view>
}
<!-- blog category -->
@case ('blog-category') {
<cms-blog-page-category-view [model]="model">
</cms-blog-page-category-view>
}
<!-- blog category -->
@case ('blog-root') {
<cms-blog-page-root-view [model]="model">
</cms-blog-page-root-view>
}
<!-- standard page -->
@default {
<icms-outlet [name]="'Page contents'"
             [main]="true"
             [components]="model.data.components || []"></icms-outlet>
}
}
}
